export const tag = 'serviceListTemplate';
export const load = async () => {
    const { ServiceListTemplateComponent } = await import('./service-list-template.component');
    return {
        component: ServiceListTemplateComponent,
    };
};
